var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class ViewSwitcher extends Component {
    constructor() {
        super('ViewSwitcher', false);
        this.views = new Map();
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Get the current view name
            this.viewName = $('.view-container').data('name');
            // Get the current views from session storage
            let rawViews = sessionStorage.getItem('views');
            if (rawViews === null || rawViews === '')
                rawViews = '{}';
            this.views = new Map(Object.entries(JSON.parse(rawViews)));
            if (!this.views.has(this.viewName))
                this.views.set(this.viewName, 'grid');
            this.update();
            this.save();
            // Reset the views when the logo is clicked
            $('.logo-link').on('click', () => {
                sessionStorage.setItem('views', '{}');
            });
            // Set the view when button is clicked
            $('.btn-set-view').on('click', (event, button) => {
                event.preventDefault();
                button.parent().find('.btn-set-view').removeClass('d-none').addClass('d-flex');
                button.addClass('d-none');
                const view = button.data('view');
                this.views.set(this.viewName, view);
                this.update();
                this.save();
            });
            // Component initialization done
            this.success();
        });
    }
    update() {
        const view = this.views.get(this.viewName);
        $('.btn-set-view').removeClass('d-none').addClass('d-flex');
        $('.btn-set-view[data-view="' + view + '"]').removeClass('d-flex').addClass('d-none');
        $('.view-container > div').addClass('d-none');
        $('.' + view + '-view').removeClass('d-none');
        LazyLoader.checkImageVisibility();
    }
    save() {
        sessionStorage.setItem('views', JSON.stringify(Object.fromEntries(this.views)));
    }
}
